import { createStyles, makeStyles } from '@mui/styles';

export const FBPurchaseOrderStyles = makeStyles(() =>
  createStyles({
    receiveAllBtn: {
      margin: '10px 0 0',
      padding: '19px 59px',
    },
  }));
